import { getMaterialFileIcon } from "file-extension-icon-js";

const getFileTypeIcon = (filename: string) => {
  const extension = filename.split(".").pop()?.toLowerCase();

  return extension;
};

const FluentUIFileTypeIcon = ({ filename }: { filename: string }) => {
  const extension = getFileTypeIcon(filename);

  const iconPath = getMaterialFileIcon(filename);

  return (
    <img
      src={iconPath}
      alt={`${extension} icon`}
      style={{ width: "24px", height: "24px" }}
    />
  );
};

export default FluentUIFileTypeIcon;
